import React from 'react';
import { connect } from 'react-redux';
import { filterNewsByCategory, filterNewsByTopic } from '../../actions/news-filter-actions';
import ListCardsImage from '../../components/ListCardsImage';
import Feed from '../../components/Feed';

const FeedContainer = ({
  archiveSlug,
  relatedNews,
  dispatch,
  relatedNewsBy,
  news,
  titleFeed
}) => {
  const handleArchiveClick = () => {
    dispatch(filterNewsByCategory({
      label: news.topic.categoryNews.name,
      value: news.topic.categoryNews.slug
    }));
    if (relatedNewsBy === 'topic') { // Only need to filter by topic when newsByTopic exists
      dispatch(filterNewsByTopic({
        label: news.topic.name,
        value: news.topic.slug
      }));
    }
  };
  return (
    <Feed
      marginTop="zero"
      marginBottom="zero"
      title={titleFeed}
      labelLink="Vedi Tutte"
      url={archiveSlug}
      hasBackground
      hasPadding
      handleArchiveClick={handleArchiveClick}
    >
      <ListCardsImage
        cards={relatedNews}
        isFeed
      />
    </Feed>
  );
};
export default connect(null)(FeedContainer);
